import api from "../services/api";
import { i18n } from "../translate/i18n";

/**
 * Inicia o fluxo de Login facilitado do Instagram (Instagram Login).
 *
 * Busca no backend a URL de autorização (com state assinado por empresa) e
 * redireciona o navegador. Ao concluir, a Meta volta para o callback do backend,
 * que provisiona a conexão e redireciona de volta para /connections?instagram=success.
 */
export const startInstagramLogin = async () => {
  const { data } = await api.get("/instagram/oauth/start");
  if (data?.url) {
    window.location.href = data.url;
    return true;
  }
  throw new Error(i18n.t("connections.toasts.instagramAuthUrlMissing"));
};

export default { startInstagramLogin };
